<div class="customer-survey-snack-bar" cdkTrapFocus>
	<div class="header">
		<h3 translate="common_give-goreact-feedback"></h3>
		<button *ngIf="mode === SurveyModes.FEEDBACK"
			class="btn-none close-btn" (click)="cancel()" attr.aria-label="{{ 'common_close' | translate }}">
			<i class="ficon-app-x"></i>
		</button>
	</div>
	<div [formGroup]="form" #content>
		<p
			*ngIf="mode === SurveyModes.RATING"
			id="feedback-description"
			class="message"
			translate="customer-feedback-description">
		</p>

		<div class="star-rating-container" *ngIf="mode === SurveyModes.RATING">
			<mat-radio-group formControlName="rating" class="star-rating" #firstFocusableElement>
				<mat-radio-button
					*ngFor="let star of [1, 2, 3, 4, 5]"
					[value]="star"
					(mouseover)="hoveredRating=star"
					(mouseleave)="hoveredRating=null"
					class="star"
					aria-describedby="feedback-description"
					[ngClass]="{'filled': hoveredRating ? star <= hoveredRating : star <= form.value.rating}">
						<i class="ficon-pointy-star"></i>
				</mat-radio-button>
			</mat-radio-group>
			<mat-error
				*ngIf="form.controls.rating.touched && form.controls.rating.hasError('required')"
				translate="customer-feedback-rating-required">
			</mat-error>
		</div>

		<mat-form-field appearance="outline" floatLabel="always">
			<mat-label translate="{{ mode === SurveyModes.RATING ? 'customer-feedback-more' : 'customer-feedback-improve' }}"></mat-label>
			<textarea matInput formControlName="feedback"
				class="feedback-field" 
				[ngClass]="{
					'rating-mode': mode === SurveyModes.RATING,
					'feedback-mode': mode === SurveyModes.FEEDBACK
				 }"></textarea>
			<mat-error
				*ngIf="form.controls.feedback.touched && form.controls.feedback.hasError('required')"
				translate="customer-feedback-feedback-required">
			</mat-error>
		</mat-form-field>
	</div>
	<div class="action-wrapper">
		<ng-container *ngIf="mode === SurveyModes.RATING else cancelOnly">
			<button
				class="tertiary-btn no-thanks"
				(click)="close()"
				translate="common_no-thanks">
			</button>
			<button
				class="tertiary-btn snooze"
				(click)="close(true)"
				translate="common_snooze">
			</button>
		</ng-container>
		<ng-template #cancelOnly>
			<button
				class="tertiary-btn cancel-btn"
				(click)="cancel()"
				translate="common_cancel">
			</button>
		</ng-template>
		<button
			class="primary-btn submit-btn"
			[focusOnFirstInvalidField]="{formGroup: form, formWrapper: content}"
			(click)="submit()"
			translate>
			common_submit
		</button>
	</div>
</div>
